<div class="product-banner grid-fluid bg-surface-decorative padding-vertical-xxbig">
  <div class="cell">
    <div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-large bg-surface-section product-banner-container">
      <div class="cell cell-large-col-span-5 cell-medium-col-span-8 cell-large-col-start-2 flex flex-column product-banner-content flex-justify-center flex-items-start">
        <h1 class="display-small margin-bottom-medium">{{ data.settings?.heading }}</h1>
        <p class="text-large margin-bottom-xmedium" [innerHTML]="data.settings?.content"></p>
        <button class="product-banner-button" *ngFor="let button of data.settings?.buttons" (click)="startQuoteEvent.emit(button.link)" mat-flat-button color="primary">{{ button.label }}</button>
      </div>
      <div class="product-banner-image cell cell-large-col-span-5 cell-medium-col-span-8" [ngStyle]="{ backgroundImage: 'url(' + data.settings?.image + ')' }"></div>
    </div>
  </div>
</div>